import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

const Home = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Update document title
        document.title = 'Instapath - Drone Operations Management Software';

        // Update meta description
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute(
                'content',
                'Platform as a Service (PAAS) featuring software for flight planning, safety, and regulatory compliance tools for drones, unmanned aerial vehicles, unmanned aerial systems, and more.'
            );
        }

        // Update meta keywords
        const metaKeywords = document.querySelector('meta[name="keywords"]');
        if (metaKeywords) {
            metaKeywords.setAttribute(
                'content',
                'Instapath Cloud, drone flight planning, drone compliance tools, unmanned aerial vehicles, UAV software, UAS flight tools, mission planning software, drone business management'
            );
        }

        // Update meta author
        const metaAuthor = document.querySelector('meta[name="author"]');
        if (metaAuthor) {
            metaAuthor.setAttribute('content', 'Rigg Dynamics LLC');
        }
    }, []); // Empty dependency array ensures this runs once on mount

    return (
        <Box
            sx={{
                padding: '96px 16px 16px', // Account for header height
                textAlign: 'center',
            }}
        >
            <Typography variant="h3" gutterBottom sx={{ color: '#34495e' }}>
                Welcome to Insta
                <Typography variant="medium" component="span">
                    path™
                </Typography>
            </Typography>
            <Typography variant="h6" gutterBottom sx={{ color: '#6c757d' }}>
                The end-to-end solution for drone operations and business management.
            </Typography>
            <Button
                variant="contained"
                color="primary"
                sx={{ marginTop: 2 }}
                onClick={() => navigate('/pricing')}
            //onClick={() => //alert('Learn More functionality coming soon!')}
            >
                Get started
            </Button>
        </Box>
    );
};

export default Home;